import { render, staticRenderFns } from "./fulfilorder.vue?vue&type=template&id=38c265bc&scoped=true&"
import script from "./fulfilorder.vue?vue&type=script&lang=js&"
export * from "./fulfilorder.vue?vue&type=script&lang=js&"
import style0 from "./fulfilorder.vue?vue&type=style&index=0&id=38c265bc&lang=less&scoped=true&"
import style1 from "./fulfilorder.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c265bc",
  null
  
)

export default component.exports